import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { faClose, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import { UserService } from '@app/services';
import { BankAccount } from '@interfaces/app';

@Component({
  selector: 'mnf-modal-bankaccount-edit',
  templateUrl: './modal-bankaccount-edit.component.html',
  styleUrls: ['./modal-bankaccount-edit.component.scss']
})
export class ModalBankaccountEditComponent implements OnInit {

  account: BankAccount;

  editForm: UntypedFormGroup;

  trash = faTrashAlt;

  close = faClose;

  constructor(
    private modal: MatDialogRef<ModalBankaccountEditComponent>,
    private fb: UntypedFormBuilder,
    private userServ: UserService,
  ) { }

  ngOnInit(): void {
    this.editForm = this.fb.group({
      alias: ['', Validators.compose([Validators.required])]
    });
  }

  updateAlias() {
    const { alias } = this.editForm.value;

    if (alias) {
      this.userServ.updateBankAccount(this.account.id, alias).subscribe(r => {
        if (r && r.id) {
          this.modal.close(r);
        }
      });
    }
  }

  cancel() {
    this.modal.close();
  }

}
